import { createSlice } from '@reduxjs/toolkit';
const initialState = {
	loginLoading: false,
	getProfileLoading: false,
	error: null,

	selectedProfile: {},
	userPermissions: [],
	profileLoadingComplete: false,

	logoutRequired: false, // use this to trigger a logout when the user updates the app.
	isLoggedIn: false,
	switchProfileLoading: false,
	signupLoading: false
};

// Create Auth reducer slice
const authSlice = createSlice({
	name: 'auth',
	initialState: initialState,
	reducers: {
		checkAuthorization: (state) => {
			state.loginLoading = true;
			state.error = null;
		},
		login: (state) => {
			state.loginLoading = true;
		},
		loginSuccess: (state) => {
			state.loginLoading = false;
			state.isLoggedIn = true;
		},
		loginError: (state, action) => {
			state.loginLoading = false;
			state.error = action.payload;
		},
		getUserProfile: (state) => {
			state.getProfileLoading = true;
			state.error = null;
		},
		getUserProfileSuccess: (state, action) => {
			state.getProfileLoading = false;
			state.selectedProfile = action.payload.selectedProfile;
			state.userPermissions = action.payload.userPermissions;
			state.profileLoadingComplete = true;
		},
		getUserProfileError: (state, action) => {
			state.getProfileLoading = false;
			state.error = action.payload;
		},
		logout: () => {
			return initialState;
		},
		switchProfile: (state) => {
			state.switchProfileLoading = true;
			state.error = null;
		},
		switchProfileSuccess: (state, action) => {
			state.switchProfileLoading = false;
			state.selectedProfile = action.payload.selectedProfile;
		},
		switchProfileError: (state, action) => {
			state.switchProfileLoading = false;
			state.error = action.payload;
		},
		signupUser: (state) => {
			state.signupLoading = true;
			state.error = null;
		},
		signupUserSuccess: (state) => {
			state.signupLoading = false;
			state.isLoggedIn = true;
		},
		signupUserError: (state, action) => {
			state.signupLoading = false;
			state.error = action.payload;
		},
		resetError: (state) => {
			if (state.error) state.error = null;
		}
	},
	extraReducers: (builder) => {
		builder.addCase('auth/logout', () => {
			return initialState; // Reset state on logout
		});
	}
});

// Export actions
export const authActions = authSlice.actions;

// Export reducer
export default authSlice.reducer;
